import axios from "axios";
import { API, getOrCreateUserId } from "./api";

export async function fetchGemPacks() {
  const user_id = getOrCreateUserId();
  const res = await axios.get(`${API}/store/packs`, { params: { user_id } });
  return {
    packs: res.data.packs,
    firstPurchaseEligible: !!res.data.first_purchase_eligible,
  };
}

export async function startCheckout(pack_id) {
  const user_id = getOrCreateUserId();
  const origin_url = window.location.origin;
  const res = await axios.post(`${API}/store/checkout`, { pack_id, origin_url, user_id });
  return res.data; // { url, session_id }
}

export async function getCheckoutStatus(session_id) {
  const res = await axios.get(`${API}/store/checkout-status/${session_id}`);
  return res.data;
}
